/* oskari BORA-Finder — Split-Variante (Variante 2, .osk-pfq).
   Eigenstaendig, unabhaengig von Finder-1 (oskari-finder.js).
   Produktdaten (Modell/Preis/URL/Bild) aus [data-osk-products] — kein Hardcode.
   4 Fragen: q1 Schmerz (Headline), q2 Anwendung (Zubehoer), q3 Anzahl (Modell),
   q4 Dringlichkeit (heiss/kalt-Pfad). */
(function () {
  'use strict';
  var CIRC = 138.2, TOTAL = 4;
  var ANZAHL_TO_KEY = { '1-2': 'bora2', '3-4': 'bora4b', '5-6': 'bora6', '7-10': 'bora10' };
  var FALLBACK = { bora2: 'BORA® 2', bora4b: 'BORA® 4 Breit', bora6: 'BORA® 6', bora10: 'BORA® 10' };
  var SCHMERZ = {
    geruch:  'So werden Ihre Schuhe wieder geruchsneutral.',
    nass:    'So sind Ihre Schuhe morgens verlässlich trocken.',
    hygiene: 'So schützen Sie sich vor Keimen & Fußpilz.',
    alles:   'Geruch, Nässe und Hygiene — auf einmal gelöst.'
  };

  function initSplit(root) {
    if (root.dataset.oskInit) return;
    root.dataset.oskInit = '1';

    var products = {};
    var pEl = root.querySelector('[data-osk-products]');
    if (pEl) { try { products = JSON.parse(pEl.textContent || '{}'); } catch (e) { products = {}; } }

    var hero = root.querySelector('[data-screen="hero"]');
    var quiz = root.querySelector('[data-screen="quiz"]');
    var fill = root.querySelector('[data-meter-fill]');
    var pct  = root.querySelector('[data-meter-pct]');
    var text = root.querySelector('[data-meter-text]');
    var answers = {};

    function setMeter(step) {
      var p = Math.round(step / TOTAL * 100);
      if (fill) fill.style.strokeDashoffset = CIRC - (CIRC * p / 100);
      if (pct)  pct.textContent = p + '%';
      if (text) text.textContent = (step >= TOTAL) ? 'Ihr Modell steht' : ('Frage ' + (step + 1) + ' von ' + TOTAL);
    }
    function showStep(name) {
      var steps = root.querySelectorAll('.osk-pfq__step');
      for (var i = 0; i < steps.length; i++) {
        var on = steps[i].getAttribute('data-step') === name;
        steps[i].hidden = !on;
        if (on) { steps[i].classList.remove('osk-pfq__fade'); void steps[i].offsetWidth; steps[i].classList.add('osk-pfq__fade'); }
      }
    }
    function set(sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }

    function renderResult() {
      var key = ANZAHL_TO_KEY[answers.q3] || 'bora4b';
      var p = products[key] || null;
      var cold = (answers.q4 === 'vergleich');

      set('[data-result-model]', p && p.title ? p.title : (FALLBACK[key] || 'Ihr BORA®'));
      set('[data-result-price]', p && p.price ? ('ab ' + p.price) : '');

      var img = root.querySelector('[data-result-img]');
      if (img) img.style.backgroundImage = (p && p.image) ? "url('" + p.image + "')" : 'none';

      var hl = root.querySelector('[data-result-highlight]');
      if (hl) hl.textContent = (cold ? '🔎 ' : '☑️ ') + (SCHMERZ[answers.q1] || 'Das passt zu Ihren Angaben.');

      var cta = root.querySelector('[data-result-cta]');
      if (cta) {
        cta.textContent = (cold ? 'Modell in Ruhe ansehen' : 'Modell ansehen') + ' →';
        cta.setAttribute('href', (p && p.url) ? p.url : '#');
      }
      showStep('result');
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="start"]')) { hero.hidden = true; quiz.hidden = false; setMeter(0); showStep('q1'); return; }
      if (e.target.closest('[data-action="restart"]')) { answers = {}; quiz.hidden = true; hero.hidden = false; return; }
      var back = e.target.closest('[data-osk-back]');
      if (back) { var to = back.getAttribute('data-osk-back'); setMeter(parseInt(to.replace('q', ''), 10) - 1); showStep(to); return; }
      var opt = e.target.closest('.osk-pfq__opt');
      if (!opt || !root.contains(opt)) return;
      var q = opt.getAttribute('data-q');
      answers['q' + q] = opt.getAttribute('data-v');
      setMeter(parseInt(q, 10));
      if (q === '4') { renderResult(); return; }
      showStep('q' + (parseInt(q, 10) + 1));
    });
  }

  function boot() {
    var all = document.querySelectorAll('[data-osk-pfq]');
    for (var i = 0; i < all.length; i++) initSplit(all[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
